module.exports = __webpack_public_path__ + "img/7.1bd3c0c2.png";